module.exports = __webpack_public_path__ + "static/en-section-1@2x-45572e6d344cb6fa84ad0a8ac9256723.png";